import { deleteCookie } from '@/utils/cookies'

export function clearAdminCookies(): void {
  deleteCookie('accessToken')
  deleteCookie('refreshToken')
  deleteCookie('idToken')
}
